 import { defineStore } from "pinia";
 
// import axios from 'axios'

// import type {
//   InputUser,
//   User
// } from "../../../services/login/admin/types";

// import type { APIResponse } from "../../../services/types";
// import { API } from "../../../services";
// import { AxiosError } from "axios";

export const useUserStore = defineStore("useUserStore", () => {

    const config = useRuntimeConfig();

    const user = ref(null);

    const { $api } = useNuxtApp();

    const loggedIn = ref(false);
  
    function initloggedIn(data) {
      loggedIn.value = data;
    }

    function initUser(data) {
        user.value = data;
    }
  
    async function checkLogin(token){
      try {
        const { status, data } = await API.user.checkLoginUser(token);
        if (status === 200) {
   
         initUser(data.user);

         initloggedIn(true)
  
          return {
            success: true,
            content: null,
          };
        }
      } catch (error) {
       
        return {
          success: false,
          status: error.response?.status,
          content: null,
        };
      }
      return {
        success: false,
        content: null,
        status: 400,
      };
    }
   
    async function logInUser(
      input
    ){
      try {

          //  await $fetch('/sanctum/csrf-cookie', {
          //     baseURL: config.public.API_BASE_URL_WEB,
          //     credentials: 'include',  
          //   });
        
         
          //  const data = await $fetch('/login', {
          //     baseURL: config.public.API_BASE_URL_WEB,
          //     credentials: 'include', 
          //     headers: {
          //           'X-XSRF-TOKEN': useCookie('XSRF-TOKEN').value  
          //       },
          //       method: 'POST',
          //       body: {
          //        ...input
          //      }, 
          //   });

          const  { update, reset} = await useSession()
        

          const data = await $api('/api/user/login',{
            method: 'POST',
            body: {
              ...input
            }
          })
         
         if (!data.success) return

          await reset()

          await update({ "token": data.data.token })
         
          initUser(data.data.user);

          initloggedIn(true);

         
        return {
          success: true,
          data: data?.data
        };

      } catch (error) {
 

        return {
          success: false,
          status: error.response?.status,
          content: null
        };

      }
    }
  
    async function logOutUser() {
      try {
        const data = await useNuxtApp().$apiAuth(`/api/admin/logout`,{
          method: 'GET',
          use: 'admin'            
       })
          return {
            success: data?.success,
            content: null,
            errorValidation: {}
          };
         
      } catch (error) {

        return {
          success: false,
          status: error.response?.status,
          content: null,
          errorValidation: error?.response?._data?.errors
        };
      }
    }
    return {
     user,
     initUser,
     logInUser,
     checkLogin,
     initloggedIn,
     loggedIn,
     logOutUser
    };
  });
